window.ParsleyConfig = {
  errorClass: 'field_with_errors',
  classHandler: function classHandler(field) {
    return field.$element.parent();
  },
  errorsWrapper: '<span class="errors-list"></span>',
  errorTemplate: '<span class="errorText"></span>'
};


// WEBPACK FOOTER //
// ./app/webpacker/src/js/parsley_config.js